export default __webpack_public_path__ + "static/media/grad.7376f334.png";